// CardIp.js

import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import ApiClient from "../ApiClient";
import { getRequestGlobal } from "../../../API/global";
import { isTimeUp } from "../../Helper";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const CardIp = ({ handlePrint, impoData }) => {
  const { getRequest, postRequest } = ApiClient();
  const [preData, setPredata] = useState([]);
  const [oldYearData, setOldYearData] = useState([]);
  const [language, setLanguage] = useState({});
  const navigate = useNavigate();
  const ipform_expiry_date = process.env.REACT_APP_IP_FORM_EXPIRY_DATE;
  const iptimeUp = isTimeUp(ipform_expiry_date);
  useEffect(() => {
    fetchData();
  }, []);

  // const [impoData, setImpoData] = useState([]);
  // let baseUrl = process.env.REACT_APP_BASE_PREFIX;
  // useEffect(() => {
  //   const ImportantData = async () => {
  //     if (!baseUrl) {

  //       return;
  //     }
  //     try {
  //       const response = await fetch(`${baseUrl}/AppData.json`);
  //       const commonData = await response.json();
  //       setImpoData(commonData);
  //       // console.log("CommonData", commonData);
  //     } catch (error) {
  //       console.error(error, "importent adta error");
  //     }
  //   };

  //   ImportantData();
  // }, []);

  // const [iptimeUp, setIpTimeUp] = useState(false);
  // const [DDtimeUP, setDdTimeUp] = useState(false);
  // const [otttimeUP, setOttTimeUp] = useState(false);

  // const isTimeUp = (dateTime) => {
  //   const now = new Date();
  //   const target = new Date(dateTime);
  //   return now > target;
  // };

  // const cleanDateString = (date, time) => {
  //   if (!date || !time) return null;
  //   const cleanedDate = date.replace(/(\d+)(st|nd|rd|th)/, "$1");
  //   return `${cleanedDate} ${time}`;
  // };

  // useEffect(() => {
  //   if (impoData?.indian_Peronoma) {
  //     const ipDate = cleanDateString(
  //       impoData.indian_Peronoma.last_date,
  //       impoData.indian_Peronoma.last_time
  //     );
  //     setIpTimeUp(isTimeUp(ipDate));
  //   }
  // }, []);

  const fetchData = async () => {
    try {
      const preData = await getRequest("list");
      const data = preData.data;
      setPredata(data);
      const olddata = preData.oldlistdata;
      console.log("old Data", olddata);
      setOldYearData(olddata);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };
  useEffect(() => {
    getRequestGlobal("language_list", {})
      .then((data) => {
        // console.log(data, "language data ip");
        setLanguage(data.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete?");
    if (confirmDelete) {
      try {
        const data = await postRequest(`delete/${id}`);
        if (data.status) {
          window.location.reload();
        }
        // setPredata(preData.filter((item) => item.id !== id));
      } catch (error) {
        console.error("Delete error:", error);
      }
    }
  };

  const handleEditClick = (id) => {
    navigate(`/ip/${id}`);
  };

  const [ipClosed, setIpClosed] = useState();

  useEffect(() => {
    if (impoData?.indian_Peronoma) {
      const IP = impoData.indian_Peronoma.close;

      console.log({ IP });
      setIpClosed(IP);
    }
  }, [impoData]);
  return (
    <>
      {preData.length === 0 ? (
        <div className="text-center">
          <p className="no-content">
            <h4>
              You haven't added any entries yet. To get started, simply click on
              Add New Entry button
            </h4>
          </p>
        </div>
      ) : (
        <div className="card-container">
          <>
            {preData.map((item) => (
              <div className="card_con" key={item.id}>
                <h1 className="title">{item.english_translation_of_film}</h1>
                <ul className="listView">
                  {/* <li><h5>Type Of Film</h5> <h6 style={{ width: 'unset' }}>{item.category == 1 ? 'Featured' : 'Non-Featured'}</h6></li> */}
                  <li>
                    <h5>Type Of Film</h5>{" "}
                    <h6 style={{ width: "unset" }}>
                      {/* {item.category == 1 ? "Feature" : "Non-feature"} */}

                      {item.category == 1
                        ? "Feature Film"
                        : item.category == 2
                          ? "Non-feature Film"
                          : item.category == 3
                            ? "Best Debut Director of Indian Feature Film"
                            : item.category == 4
                              ? "New Horizon"
                              : ""}
                    </h6>
                  </li>
                  <li>
                    <h5>
                      Language of <br />
                      Sub Title
                    </h5>{" "}
                    <h6 style={{ width: "unset" }}>
                      {language?.[item.language_id] || ""}
                    </h6>
                  </li>
                </ul>
                <div className="button_con">
                  {item.step >= 9 ? (
                    <>
                      <Button
                        // style={{ backgroundColor: "#1c5768", color: "#fff" }}
                        onClick={() => navigate(`/ip/view/${item.unique_id}`)}
                      >
                        View & Print
                      </Button>
                    </>
                  ) : (
                    <>
                      {ipClosed === 1 ? (
                        <>
                          <Button
                            variant="contained"
                            onClick={() => handleEditClick(item.unique_id)}
                          >
                            <EditIcon />
                            Edit
                          </Button>
                          <Button
                            className="del_btn"
                            variant="contained"
                            onClick={() => handleDelete(item.unique_id)}
                            startIcon={<DeleteIcon sx={{ color: "#f67474" }} />}
                          >
                            Delete
                          </Button>
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                </div>
              </div>
            ))}
          </>
        </div>
      )}

      {!Object.keys(oldYearData).length ? (
        <div className="card_con mt-4">
          <Typography variant="body1">
            No previous submissions available.
          </Typography>
        </div>
      ) : (
        Object.entries(oldYearData)
          .sort((a, b) => Number(b[0]) - Number(a[0])) // Sort years descending (latest first)
          .map(([year, items]) => (
            <Accordion sx={{ mt: 2 }} key={year} className="accordian_class">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel-${year}-content`}
                id={`panel-${year}-header`}
              >
                <Typography variant="h6" component="span">
                  Your Previous Submissions - {year}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="card-container">
                  {items.map((item) => (
                    <div className="card_con" key={item.id}>
                      <h2 className="title">
                        {item.english_translation_of_film ||
                          "Untitled Submission"}
                      </h2>
                      <ul className="listView">
                        <li>
                          <h5>Type Of Film</h5>
                          <h6 style={{ width: "unset" }}>
                            {Number(item.category) === 1
                              ? "Feature"
                              : "Non-feature"}
                          </h6>
                        </li>
                        <li>
                          <h5>
                            Language of <br />
                            Subtitle
                          </h5>
                          <h6 style={{ width: "unset" }}>
                            {language?.[item.language_id] || "N/A"}
                          </h6>
                        </li>
                      </ul>
                      {/* <div className="button_con">
                        <Button
                          variant="contained"
                          onClick={() => navigate(`/ip/view/${item.id}`)}
                        >
                          View & Print
                        </Button>
                      </div> */}
                    </div>
                  ))}
                </div>
              </AccordionDetails>
            </Accordion>
          ))
      )}
    </>
  );
};

export default CardIp;
